// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ad493c63","977":"0216a576"}[chunkId] + ".chunk.js";
};